import React from 'react';
import styles from './styles.module.css';
import SectionHead from '@/components/general/SectionHead';
import BlogCover from '@/components/pages/home/HomeContent/SampleBlogs/BlogCard/BlogCover';
import AppImage from '@/components/common/AppImage';
import MainIcons from '@/icons/main';
import FeatCard from '@/components/pages/home/HomeContent/Features/FeatCard';
import { avatarBg, avatarBgGlow } from '@/functions/formats';

export default function AboutUsContent() {
  const info = [
    {
      id: 1,
      t: 'دیدگاه ما',
      d: 'ما باور داریم آینده‌ی خدمات خودرویی، دیجیتال و شخصی‌سازی‌شده است. کارا فقط یک وبسایت نیست؛ بلکه گامی به سمت آینده‌ای است که در آن مدیریت خودرو، به‌سادگی چند لمس روی صفحه خواهد بود. در چشم‌انداز ما، کاربران نه‌تنها از خدمات موجود بهره می‌برند، بلکه با نوآوری‌هایی روبه‌رو خواهند شد که حتی فکرش را هم نمی‌کردند. ما می‌خواهیم "مدیریت خودرو" را دوباره تعریف کنیم.',
      icon: <MainIcons.EyeOn />,
      bg: 'var(--danger-bg)',
      fill: 'var(--danger)',
    },
    {
      id: 2,
      t: 'رویکرد ما',
      d: 'در کارا، رویکرد ما همیشه "سادگی در عین قدرت" بوده. ما به جای پیچیده‌ کردن فرآیندها، به دنبال ساختن تجربه‌ای بی‌دردسر و روان برای کاربران هستیم. طراحی ساده، اطلاعات شفاف، و خدمات دقیق سه ستون اصلی در توسعه‌ی سرویس‌های ما هستند. ما با گوش دادن به نیاز کاربران و تحلیل بازخوردهای آن‌ها، مسیر توسعه را شکل می‌دهیم. هر قابلیتی که اضافه می‌کنیم، باید واقعاً به زندگی روزمره کاربران کمک کند.',
      icon: <MainIcons.SampleIcon />,
      bg: 'var(--green-bg)',
      fill: 'var(--green)',
    },
    {
      id: 3,
      t: 'داستان ما',
      d: 'ایده‌ی کارا از یک دغدغه ساده شروع شد؛ چرا برای مشاهده و پرداخت خلافی خودرو باید این‌همه زمان صرف کنیم؟ ما تصمیم گرفتیم راه‌حلی بسازیم که این فرآیند را ساده، سریع و بدون دردسر کند. با ترکیب فناوری و تجربه‌ی کاربری، کارا متولد شد تا کاربران بتوانند تنها با وارد کردن پلاک، همه چیز را در لحظه ببینند و مدیریت کنند. حالا هزاران کاربر به کارا اعتماد کرده‌اند و هر روز، راحت‌تر از همیشه امور خودرویی‌شان را پیش می‌برند. این تازه شروع ماست...',
      icon: <MainIcons.ChatIcon />,
      bg: 'var(--tag-bg)',
      fill: 'var(--brand-deep)',
    },
    {
      id: 4,
      t: 'هدف ما',
      d: 'هدف اصلی ما، ساخت بستری امن، سریع و ساده برای مدیریت تمام خدمات مرتبط با خودرو است. می‌خواهیم هر راننده‌ای بدون مراجعه حضوری یا صرف زمان زیاد، بتواند امور خودرویش را در لحظه پیگیری کند. با گسترش خدمات و بهبود مداوم تجربه‌ی کاربری، کارا به دنبال آن است که به انتخاب اول رانندگان در سراسر کشور تبدیل شود. برای ما، رضایت شما تنها هدف نیست، بلکه انگیزه‌ای برای بهتر شدن است.',
      icon: <MainIcons.coinIcon />,
      bg: 'var(--accent-bg)',
      fill: 'var(--accent)',
    },
  ];

  return (
    <>
      <div className={`${styles.container}`}>
        <SectionHead
          tag={'داستان کارا'}
          title={'از یک ایدهٔ ساده تا سامانهٔ جامع خودرو'}
          text="کارا یک سامانه هوشمند خدمات خودرویی است که با تمرکز بر پرداخت خلافی، مدیریت چند خودرو، و ارائه اطلاعات دقیق به کاربران فعالیت می‌کند. ما با استفاده از جدیدترین تکنولوژی‌ها و طراحی تجربه‌محور، بستری ایجاد کرده‌ایم تا رانندگان بتوانند به‌سادگی خودروهای خود را پیگیری و کنترل کنند. خدمات ما آنلاین، سریع و بدون نیاز به مراجعه حضوری است. تیم کارا از متخصصان حوزه فناوری، طراحی و خدمات مشتری تشکیل شده است."
          headingTag="h2"
          type="otherPages"
          titleClass={styles.titleClass}
          textTitle={`${styles.textClass}`}
          wrapper={`${styles.wrapper}`}
        />
        {/* <BlogCover className={`${styles.cover}`} /> */}
        <AppImage
          src="/imgs/about/aboutUs.svg"
          className={`${styles.image}`}
          // className={`${styles.cover}`}
          // width={600}
          // height={351}
        />
      </div>
      <div className={`${styles.infoGrid}`}>
        {info?.map((item, index) => (
          <FeatCard key={index} f={item} index={index} fill={item?.fill} headTag="h2" />
        ))}
      </div>
    </>
  );
}
